// extracted by mini-css-extract-plugin
export default {"root":"sd6deD1-gVbe-yJ7in25Hw==","label":"_79JMtNCnKWgUM+hc5qqh9A==","details":"_6V2FntZ83KWUEgGynK5aog==","action":"m8oUYNAln6DsoNSPHoQGOg==","revoked":"ws296bwudCqtWplgtaHPnw=="};